module.exports = __webpack_public_path__ + "img/AND.4a075464.svg";